import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useT } from '../../i18n';
import { useAuth } from '../../providers/AuthProvider';

/**
 * The console's guard. Unlike RequireAuth it sends everyone to /admin/login —
 * the admin door — rather than the booker login page, so the two sign-in
 * surfaces stay separate. A signed-in non-admin lands there too and is told
 * why (see AdminLoginPage), instead of being silently bounced home.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { t } = useT();
  const { user, isLoading } = useAuth();

  if (isLoading)
    return (
      <p className="muted" style={{ padding: 24 }}>
        {t('loading')}
      </p>
    );
  if (user?.role !== 'admin') return <Navigate to="/admin/login" replace />;

  return <>{children}</>;
}
